export const RESET = 'MEDIA_OBJECT_LIST_RESET'
export const SET_ITEMS = 'MEDIA_OBJECT_LIST_SET_ITEMS'
export const SET_ERROR = 'MEDIA_OBJECT_LIST_SET_ERROR'
export const SET_SELECT_ITEMS = 'MEDIA_OBJECT_LIST_SET_SELECT_ITEMS'
export const SET_VIEW = 'MEDIA_OBJECT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'MEDIA_OBJECT_LIST_TOGGLE_LOADING'
